import { render, staticRenderFns } from "./ASkipToContent.vue?vue&type=template&id=554ac88c&scoped=true&"
import script from "./ASkipToContent.vue?vue&type=script&lang=js&"
export * from "./ASkipToContent.vue?vue&type=script&lang=js&"
import style0 from "./ASkipToContent.vue?vue&type=style&index=0&id=554ac88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ac88c",
  null
  
)

export default component.exports